import { render } from "./ProductDetails.vue?vue&type=template&id=4e116206&scoped=true&ts=true"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"

import "./ProductDetails.vue?vue&type=style&index=0&id=4e116206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e116206"]])

export default __exports__